import { apiFetch } from './apiFetch';
import type { BoxPlan, BoxSettings, EmbedLoginResponse, SessionUser } from '@salaries/shared';

export async function embedLogin(accessToken: string): Promise<EmbedLoginResponse> {
  return apiFetch<EmbedLoginResponse>('/auth/embed-login', {
    method: 'POST',
    body: JSON.stringify({ accessToken }),
  });
}

/** DEV-ONLY: seed a sample box + mint a session (server gates by ENABLE_DEV_LOGIN). */
export async function devLogin(): Promise<EmbedLoginResponse> {
  return apiFetch<EmbedLoginResponse>('/auth/dev-login', { method: 'POST' });
}

export interface MeResponse {
  user: SessionUser;
  settings: BoxSettings;
  onboarding_completed: boolean;
  /** Commercial plan — drives the deactivated block + hiding the send flow. */
  plan: BoxPlan;
}

export async function fetchMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/me');
}
